import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-library-rules',
  templateUrl: './library-rules.component.html',
  styleUrls: ['./library-rules.component.scss']
})
export class LibraryRulesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
